import { gql } from '@apollo/client'

export const BUSINESS_ACTIVITIES_TREE_QUERY = gql`
  query BUSINESS_ACTIVITIES_TREE_QUERY($pagination: PaginationInput, $filter: BusinessActivityFilterInput) {
    businessActivities(pagination: $pagination, filter: $filter) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        id
        code
        active
        expanded
        parentId
        description
        createdAt
        position
        parent {
          id
          description
        }
      }
    }
  }
`

export const BUSINESS_ACTIVITIES_SELECT_QUERY = gql`
  query BUSINESS_ACTIVITIES_SELECT_QUERY($filter: BusinessActivityFilterInput, $pagination: PaginationInput) {
    businessActivities(filter: $filter, pagination: $pagination) {
      pagination {
        pageSkip
        pageTake
        totalCount
      }
      data {
        id
        active
        description
        parent {
          id
          description
        }
      }
    }
  }
`
